import { render, staticRenderFns } from "./FormInputRadio.vue?vue&type=template&id=754ab200&"
import script from "./FormInputRadio.vue?vue&type=script&lang=js&"
export * from "./FormInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('754ab200')) {
      api.createRecord('754ab200', component.options)
    } else {
      api.reload('754ab200', component.options)
    }
    module.hot.accept("./FormInputRadio.vue?vue&type=template&id=754ab200&", function () {
      api.rerender('754ab200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputRadio.vue"
export default component.exports